"use client"
import { IYourCurrentPlanItem, IYourCurrentPlanItems, IProduct } from '@/types';
import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';;
import { CommonHexagonBadge } from './CommonHexagonBadge';
import { KeenIcon } from '../../common/keenicons';
import Link from 'next/link';

const YourCurrentPlan = () => {
    const membershipUrl = process.env.NEXT_PUBLIC_STORE_URL;
    return (
        <Fragment>
            <style>
                {`
          .upgrade-bg {
            background-image: url('/assets/media/images/2600x1200/bg-5.png');
          }
          .dark .upgrade-bg {
            background-image: url('/assets/media/images/2600x1200/bg-5-dark.png');
          }
        `}
            </style>

            <div className="card rounded-xl">
                <div className="flex items-center flex-wrap sm:flex-wrap justify-between grow gap-2 p-5 rtl:[background-position:-30%_41%] [background-position:121%_41%] bg-no-repeat bg-[length:660px_310px] upgrade-bg">
                    <div className="flex items-center gap-4">
                        <CommonHexagonBadge
                            stroke="stroke-brand-clarity"
                            fill="fill-brand-light"
                            size="size-[50px]"
                            badge={<KeenIcon icon="people " className="text-xl text-brand" />}
                        />

                        <div className="flex flex-col gap-1.5">
                            <div className="flex items-center flex-wrap gap-2.5">
                                <span
                                    className="text-base font-medium text-gray-900"
                                >
                                    <FormattedMessage id="UPGRADE_MEMBERSHIP" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center gap-1.5">
                        <div>
                            <Link href={`${membershipUrl || '#'}/?category=membership`} className="btn btn-sm btn-dark">
                                <FormattedMessage id="UPGRADE_PLANE" />
                            </Link>

                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export { YourCurrentPlan, type IYourCurrentPlanItem, type IYourCurrentPlanItems };